import React from 'react'
import { BannerDetailFormStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  Switcher,
  InputUpload,
  Modal,
} from '../../components'
import { ICONS, CONTENTS } from '../../themes'

import { ROUTE_PATH, redirect, STRING, getCroppedImg } from '../../helpers'

import Cropper from 'react-easy-crop'
import { Slider } from '@material-ui/core'

export class BannerDetailFormContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      width: window.innerWidth,

      modals: [{ name: 'crop', isOpen: false }],
      isEditPageState: false,
      isActive: false,

      selectedFile: undefined,
      selectedImage: undefined,
      crop: { x: 0, y: 0 },
      zoom: 2,
      zoomSpeed: 0.5,
      minZoom: 1,
      maxZoom: 5,
      aspect: 16 / 9,
      croppedAreaPixels: undefined,
      croppedImage: undefined,
    }
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth })
  }
  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }
  calZoomReverse = width => {
    if (width < 1024) return 2
    else if (1024 <= width <= 1920) {
      let temp = (width - 1024) / (896 * 2)
      let tempReverse = 1 / (1 - (0.5 - temp.toFixed(2)))
      return tempReverse.toFixed(2)
    } else return 1
  }
  calZoom = width => {
    if (width < 1024) return 2
    else if (1024 <= width <= 1920) {
      let temp = (width - 1024) / (896 * 2)
      return 1 - (0.5 - temp.toFixed(2))
    } else return 1
  }

  handleChange = () => {
    this.setState(prevState => ({
      isActive: !prevState.isActive,
    }))
  }

  onImageChange = event => {
    this.setState(
      {
        selectedFile: event.target.files[0],
        selectedImage: URL.createObjectURL(event.target.files[0]),
      },
      () => {
        console.log('selected file' + this.state.selectedFile)
        this.toggleModal('crop')
      }
    )
  }

  onCropChange = crop => {
    this.setState({ crop })
  }

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    this.setState({ croppedAreaPixels })
    // console.log(croppedArea, croppedAreaPixels)
  }
  onZoomChange = zoom => {
    this.setState({ zoom })
  }

  async onShowCroppedImage() {
    //try {
    const croppedImage = await getCroppedImg(
      this.state.selectedImage,
      this.state.croppedAreaPixels
    )
    console.log('donee', this.state.croppedImage)
    this.setState(
      {
        croppedImage: croppedImage,
      },
      () => {
        this.toggleModal('crop')
      }
    )
    // } catch (e) {
    //   console.error(e)
    // }
  }

  toggleModal = id => {
    this.setState(
      prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === id ? !modal.isOpen : false,
        })),
      })
      // () => {
      //   console.log(this.state.modals)
      // }
    )
  }

  render() {
    const {
      isEditPageState,
      isActive,
      modals,
      selectedFile,
      selectedImage,
      zoom,
      minZoom,
      maxZoom,
      crop,
      aspect,
      croppedImage,
    } = this.state

    return (
      <React.Fragment>
        <BannerDetailFormStyle>
          {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_banner_management"
                  src={ICONS['icon-display-star.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_banner_management" className="title">
                  {STRING.BANNER_MANAGEMENT}
                </Section>

                <Section
                  id="page_breadcrumb_banner_management"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.BANNER_MANAGEMENT}</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>
                      {isEditPageState ? 'Edit Banner' : 'Create Banner'}
                    </span>
                  </Button>
                </Section>
              </Section>
            </Section>
          </Section>

          {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
          <Section className="main-content form">
            <Section className="content-body">
              <Section className="form-wrapper">
                <Section className="form-group-title">
                  {isEditPageState ? 'Edit Banner' : 'Create Banner'}
                </Section>

                <Section className="form-group">
                  <label>Banner</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <InputUpload
                        id="upload"
                        selectedFileName={
                          selectedFile !== undefined ? selectedFile.name : ''
                        }
                        onChange={this.onImageChange}
                        accept="image/*"
                      />
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>

                <Section className="result-image">
                  {croppedImage !== undefined ? (
                    <Button
                      className="link"
                      onClick={() => this.toggleModal('crop')}
                    >
                      <Image src={croppedImage} />
                    </Button>
                  ) : (
                    <Image
                      src={ICONS['icon-gallery-white.svg']}
                      className="icon-default-no-banner"
                      alt="no banner"
                    />
                  )}
                </Section>

                <Section className="form-group">
                  <label>URL</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Input type="text" />
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>

                {isEditPageState && (
                  <Section className="form-group">
                    <label>Active</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Switcher
                          onChange={this.handleChange}
                          checked={isActive}
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                )}
              </Section>

              <Section className="form-actions">
                <Button className="theme-border-gray">Cancel</Button>

                <Button className="theme-green">Save</Button>
              </Section>
            </Section>
          </Section>
        </BannerDetailFormStyle>

        <Modal
          id="crop_banner_id"
          className="banner-management admin cropper theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'crop'
              })
              .map(obj => obj.isOpen)[0]
          }
          //demoZoomReverse={this.calZoomReverse(this.state.width)}
          //demoZoom={this.calZoom(this.state.width)}
        >
          <Modal.Header>Image</Modal.Header>

          <Modal.Body>
            <Section className="cropper-control">
              <Cropper
                image={selectedImage}
                crop={crop}
                cropSize={{ width: 640, height: 360 }}
                zoom={zoom}
                minZoom={minZoom}
                maxZoom={maxZoom}
                aspect={aspect}
                showGrid={false}
                onCropChange={this.onCropChange}
                onCropComplete={this.onCropComplete}
                onZoomChange={this.onZoomChange}
                // onImageLoaded={imageSize => {
                //   // Adapt zoom based on image size to fit max height
                //   setZoom(CONTAINER_HEIGHT / imageSize.naturalHeight)
                // }}
              />
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Section className="zoom-controls-wrapper">
              <Image
                className="zoom-icon zoom-out"
                src={ICONS['icon-image-crop-zoom-out.svg']}
                alt="zoom out"
              />
              <Slider
                value={zoom}
                min={1}
                max={5}
                step={0.2}
                aria-labelledby="Zoom"
                onChange={(e, zoom) => this.onZoomChange(zoom)}
                className="slider"
              />
              <Image
                className="zoom-icon zoom-in"
                src={ICONS['icon-image-crop-zoom-in.svg']}
                alt="zoom in"
              />
            </Section>

            <Section className="actions">
              <Button
                id="close_modal_crop_id"
                className="theme-border-gray cancel"
                onClick={() => this.toggleModal('crop')}
              >
                Cancel
              </Button>

              <Button
                id="crop_image_id"
                className="theme-green confirm"
                onClick={
                  () => {
                    this.onShowCroppedImage()
                  }
                  // console.log('eeeeeeeeeeeeeeeeeeee'))
                }
              >
                Done
              </Button>
            </Section>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}
